// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"db91e003","433":"1aecef75","777":"9c490a4e"}[chunkId] + ".chunk.js";
};